<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/18Fiypy/tc-custom/9781783408269.jpg?1706644199617" alt="This image is the cover for the book Foul Deeds & Suspicious Deaths in Guernsey, Foul Deeds & Suspicious Deaths"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Foul Deeds & Suspicious Deaths in Guernsey, Foul Deeds & Suspicious Deaths
      </h1>
      <p class="bookDescription body article font2">
        <p>The twin fascinations of death and villainy will always hold us in their grim but thrilling grip. In Foul Deeds and Suspicious Deaths in Guernsey the chill is brought close to home as each chapter investigates the darker side of humanity in cases of murder, deceit and pure malice. From crimes of passion to opportunistic killings and coldly premeditated acts of murder, the full spectrum of criminality is recounted here, bringing to life the sinister history of Guernsey from the Middle Ages to the twentieth century. For this journey into Guernsey's bloody, neglected past, Glynis Cooper has selected over 20 notorious episodes that give a fascinating insight into criminal acts and the criminal mind. Recalled here are the witch trials of medieval and much more recent times; murderous monks, smugglers and pirates; ecclesiastical executions; disappearances; murders attributed to magic and more mundane but nonetheless extraordinary cases like that of the girl who collapsed and died of shock after her fiance was murdered by a suicidal rival. The human dramas she describes are often played out in the mostcommonplace of circumstances, but others are so odd as to be stranger than fiction. Her grisly chronicle of Guernsey's hidden history will be compelling reading for anyone who is interested in the dark side of human nature.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Glynis Cooper
      </h2>
      
      <p class="authorDescription body article">Glynis Coopers family has its roots in the industrial millscapes of Manchester. She was born in Stockport, but she grew up near Bury St Edmunds and subsequently spent ten years living and working in Cambridge before returning to Manchester. Her parents were writers who inspired her enthusiasm for the written word. Glynis, who loves islands and the open countryside, trained in the dual disciplines of librarianship and archaeology. She enjoys reading, researching and writing local histories, travelling and playing chess.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?0db62f58